export function PostureIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.9 19 6v5.5c0 4-3 7.3-7 8.5-4-1.2-7-4.5-7-8.5V6l7-3.1Z"
        fill="#3E8BFF"
      />
      <path
        d="m9.3 12 1.9 1.9 3.4-3.6"
        stroke="#FFFFFF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
